<template>

    <div v-if="loaded">
        <div class="nav-tabs-custom submenu">
            <ul class="nav nav-tabs nav-fixed-tabs">
                <li
                    v-for="child in getMenu"
                    :class="{'active':isActiveChildRoute(child)}"
                >
                    <router-link :to="routeTo(child)">
                        {{ child.name }}
                    </router-link>
                </li>
            </ul>
        </div>

        <router-view
            @contactDataChanged="update"
        ></router-view>
    </div>
    <div v-else>
        <loader></loader>
    </div>

</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import Loader from "../../../components/Common/Loader";
import MenuItem from "../../../Libraries/MenuItem";

export default {

    components: {
        Loader,
    },

    computed: {
        ...mapGetters([
            'getContact',
        ]),

        getMenu() {
            let menu = [
                new MenuItem(this.getContact.fullname, {name:'crm.contacts.show', params:{uuid:this.getContact.uuid}}),
            ];

            return menu;
        },
    },

    data() {
        return {
            loaded:false,
        }
    },

    methods: {
        ...mapActions([
            'setContact',
            'setHasSubMenu',
        ]),

        getContactData(uuid) {
            axios.get(this.route('api.v1.crm.contacts.show', {uuid:uuid}))
                .then(resp => {
                    this.setContact(resp.data.data);
                    this.loaded = true;
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van de contactpersonen'));
        },

        isActiveChildRoute(child) {
            let routeName;
            if (typeof child.route === 'string') {
                routeName = child.route;
            } else {
                routeName = child.route.name;
            }

            if (routeName == 'crm.contacts.show' && this.$route.name == 'crm.contacts.edit') {
                return true;
            }

            return routeName === this.$route.name;
        },

        routeTo(child) {
            if (typeof child.route === 'string') {
                return {name:child.route};
            }
            return {
                name:child.route.name,
                params:child.route.params,
            };
        },

        update() {
            this.getContactData(this.$route.params.uuid);
        },
    },

    mounted(){
        this.update();
        this.setHasSubMenu(true);
    },

    destroyed() {
        this.setHasSubMenu(false);
    },

    name:'CrmContactsLayout',

}

</script>
